function Arrow() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='9'
			height='10'
			viewBox='0 0 9 10'
			fill='none'
		>
			<path
				d='M3.375 7.25L5.625 5L3.375 2.75'
				stroke='#E0DFF5'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	)
}

export default Arrow
